import styles from './Skeleton.module.css'

interface SkeletonProps {
  height?: number | string
  width?: number | string
  radius?: string
}

export function Skeleton({ height = 16, width = '100%', radius }: SkeletonProps) {
  return (
    <span
      className={styles.skeleton}
      style={{ height, width, borderRadius: radius, display: 'block' }}
      aria-hidden="true"
    />
  )
}

/** Несколько строк подряд — типичная заглушка для формы или списка. */
export function SkeletonStack({ rows = 3, height = 52 }: { rows?: number; height?: number }) {
  return (
    <div className={styles.stack}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={height} radius="var(--radius-sm)" />
      ))}
    </div>
  )
}
